'use client';

/**
 * Spec 42 §6 Phase F — conditional footer.
 *
 * Most (public) routes render the marketing footer at the bottom of
 * the column. A few auth-surface pages (currently just `/login`) are
 * stand-alone landing surfaces per the spec; the nav stays but the
 * footer would be visual noise. Listing them here keeps the gating
 * decision in one place.
 */
import { MarketingFooter } from '@repo/marketing-ui';
import { usePathname } from 'next/navigation';

const NO_FOOTER_PREFIXES = ['/login'];

export function FooterGate() {
  const pathname = usePathname() ?? '';
  for (const p of NO_FOOTER_PREFIXES) {
    if (pathname === p || pathname.startsWith(`${p}/`)) return null;
  }
  return <MarketingFooter />;
}
